import { useEffect } from 'react'
import { orders, projects } from '../data/adminExtendedData'

const SCHEDULE_KEY = 'difan-admin-home-schedules-v2'
const GENERAL_BANNER_SCHEDULE_KEY = 'difan-admin-general-banner-schedules-v1'
function text(value) { return String(value || '').replace(/\s+/g, ' ').trim() }
function readJson(key, fallback = {}) { try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback } catch { return fallback } }
function writeJson(key, value) { try { localStorage.setItem(key, JSON.stringify(value)) } catch {} }

function renameLabels() {
  document.querySelectorAll('.admin-content dt,.admin-content th,.admin-content span,.admin-content small,.admin-content strong').forEach((node) => {
    const value = text(node.textContent)
    if (value === '회원 ID' || value === '고객 ID') node.textContent = '회원번호'
    if (value === '운영 연결') node.textContent = '거래·정산'
  })
}
function normalizeWon() {
  document.querySelectorAll('.admin-content strong,.admin-content td,.admin-content dd,.admin-content small').forEach((node) => {
    const value = text(node.textContent)
    const match = value.match(/^₩\s*([0-9.]+)M$/i)
    if (match) node.textContent = `${Math.round(Number(match[1]) * 1000000).toLocaleString('ko-KR')}원`
    else if (/^₩[\d,]+$/.test(value)) node.textContent = `${Number(value.replace(/[^\d]/g, '')).toLocaleString('ko-KR')}원`
  })
}
function updateDirectorTabs(route) {
  if (!/^\/directors\/[^/]+$/.test(route)) return
  document.querySelectorAll('.tabs button').forEach((button) => { if (text(button.textContent) === '운영 연결') button.textContent = '거래·정산' })
  const portfolioCard = Array.from(document.querySelectorAll('.card')).find((card) => text(card.querySelector('h2')?.textContent).startsWith('공개 포트폴리오'))
  portfolioCard?.querySelectorAll('button').forEach((button) => { if (text(button.textContent).includes('운영 연결')) button.textContent = '거래·정산 보기' })
  const active = Array.from(document.querySelectorAll('.tabs button')).find((button) => button.classList.contains('active'))
  if (text(active?.textContent) === '거래·정산') {
    document.querySelectorAll('.card').forEach((card) => {
      const title = text(card.querySelector('h2')?.textContent)
      if (['공개 프로필 확장 정보', '자주 묻는 질문', '사진·포트폴리오 운영 연결'].includes(title)) card.style.display = 'none'
      if (title === '관련 거래·운영 이력') { const heading = card.querySelector('h2'); if (heading) heading.textContent = '거래·정산 현황' }
    })
  }
}
function enhanceHomeSelection(route) {
  if (route !== '/content/home') return
  document.querySelectorAll('.admin-modal').forEach((modal) => {
    const title = text(modal.querySelector('h2')?.textContent)
    const chips = modal.querySelector('.admin-chip-list')
    if (chips && !modal.querySelector('[data-selection-search]')) {
      const input = document.createElement('input'); input.dataset.selectionSearch = 'true'; input.className = 'admin-selection-search'; input.placeholder = title.includes('디렉터') ? '디렉터명, 활동명, 서비스 카테고리 검색' : '포트폴리오명, 디렉터명, 카테고리 검색'; chips.before(input)
      input.addEventListener('input', () => { const q = text(input.value).toLowerCase(); chips.querySelectorAll('button').forEach((button) => { button.style.display = !q || text(button.textContent).toLowerCase().includes(q) ? '' : 'none' }) })
    }
    if (/히어로 슬라이드|프로모션 배너/.test(title) && !modal.querySelector('[data-home-schedule]')) {
      const form = modal.querySelector('form') || modal.querySelector('.admin-modal-body'); if (!form) return
      const type = title.includes('히어로') ? 'hero' : 'promo'
      const titleInput = Array.from(modal.querySelectorAll('input')).find((input) => input.closest('.admin-form-field')?.querySelector(':scope > span')?.textContent?.includes('제목'))
      const keyFor = () => `${type}:${text(titleInput?.value) || 'new'}`
      const stored = readJson(SCHEDULE_KEY, {})[keyFor()] || {}
      const box = document.createElement('div'); box.dataset.homeSchedule = 'true'; box.className = 'admin-schedule-grid'; box.innerHTML = '<label>노출 시작 일시<input type="datetime-local" step="1" data-start-at></label><label>노출 종료 일시<input type="datetime-local" step="1" data-end-at></label>'
      box.querySelector('[data-start-at]').value = stored.startAt || ''; box.querySelector('[data-end-at]').value = stored.endAt || ''; form.appendChild(box)
      form.addEventListener('submit', (event) => {
        const startAt = box.querySelector('[data-start-at]').value; const endAt = box.querySelector('[data-end-at]').value
        if (startAt && endAt && new Date(endAt) <= new Date(startAt)) { event.preventDefault(); event.stopPropagation(); alert('노출 종료 일시는 시작 일시보다 이후여야 합니다.'); return }
        const all = readJson(SCHEDULE_KEY, {}); all[keyFor()] = { startAt, endAt, updatedAt: new Date().toISOString() }; writeJson(SCHEDULE_KEY, all)
      }, true)
    }
  })
}

function enhanceGeneralBannerSchedule(route) {
  if (route !== '/content/banners') return
  document.querySelectorAll('.admin-modal').forEach((modal) => {
    const title = text(modal.querySelector('h2')?.textContent)
    if (!title.includes('배너') || modal.querySelector('[data-general-banner-schedule]')) return
    const form = modal.querySelector('form') || modal.querySelector('.admin-modal-body')
    if (!form) return
    const nameInput = Array.from(modal.querySelectorAll('input')).find((input) => input.closest('.admin-form-field')?.querySelector(':scope > span')?.textContent?.includes('배너명'))
    if (!nameInput) return
    const keyFor = () => `banner:${text(nameInput.value) || 'new'}`
    const stored = readJson(GENERAL_BANNER_SCHEDULE_KEY, {})[keyFor()] || {}
    const box = document.createElement('div')
    box.dataset.generalBannerSchedule = 'true'
    box.className = 'admin-schedule-grid'
    box.innerHTML = '<label>노출 시작 일시<input type="datetime-local" step="1" data-general-start-at><small>비워두면 저장 즉시 노출 가능 · 시·분·초 설정</small></label><label>노출 종료 일시<input type="datetime-local" step="1" data-general-end-at><small>비워두면 종료 제한 없음 · 시·분·초 설정</small></label>'
    box.querySelector('[data-general-start-at]').value = stored.startAt || ''
    box.querySelector('[data-general-end-at]').value = stored.endAt || ''
    form.appendChild(box)
    form.addEventListener('submit', (event) => {
      const startAt = box.querySelector('[data-general-start-at]').value
      const endAt = box.querySelector('[data-general-end-at]').value
      if (startAt && endAt && new Date(endAt) <= new Date(startAt)) {
        event.preventDefault(); event.stopPropagation(); alert('노출 종료 일시는 시작 일시보다 이후여야 합니다.'); return
      }
      const all = readJson(GENERAL_BANNER_SCHEDULE_KEY, {})
      all[keyFor()] = { startAt, endAt, updatedAt: new Date().toISOString() }
      writeJson(GENERAL_BANNER_SCHEDULE_KEY, all)
    }, true)
  })

  const scheduleMap = readJson(GENERAL_BANNER_SCHEDULE_KEY, {})
  document.querySelectorAll('.admin-content table.data-table tbody tr').forEach((row) => {
    if (row.querySelector('[data-general-banner-schedule-summary]')) return
    const name = text(row.querySelector('td strong')?.textContent)
    if (!name) return
    const schedule = scheduleMap[`banner:${name}`]
    if (!schedule?.startAt && !schedule?.endAt) return
    const firstCell = row.querySelector('td')
    if (!firstCell) return
    const summary = document.createElement('small')
    summary.dataset.generalBannerScheduleSummary = 'true'
    summary.textContent = `노출 ${schedule.startAt || '즉시'} ~ ${schedule.endAt || '종료 제한 없음'}`
    firstCell.appendChild(summary)
  })
}

function redirectLegacyRoutes(route) {
  if (route === '/projects') { window.location.hash = '#/orders'; return }
  if (/^\/projects\/[^/]+$/.test(route)) {
    const project = projects.find((item) => item.id === route.split('/').pop())
    const order = orders.find((item) => item.id === project?.orderId || item.orderNo === project?.orderNo)
    window.location.hash = order ? `#/orders/${order.id}` : '#/orders'
    return
  }
  if (route.startsWith('/support/conversations')) window.location.hash = '#/refunds'
}

export default function AdminFlowParityV3() {
  useEffect(() => {
    const apply = () => {
      const route = (window.location.hash.replace(/^#/, '') || '/').split('?')[0]
      renameLabels()
      normalizeWon()
      updateDirectorTabs(route)
      enhanceHomeSelection(route)
      enhanceGeneralBannerSchedule(route)
      redirectLegacyRoutes(route)
    }
    apply()
    const observer = new MutationObserver(apply)
    observer.observe(document.body, { childList: true, subtree: true })
    window.addEventListener('hashchange', apply)
    return () => { observer.disconnect(); window.removeEventListener('hashchange', apply) }
  }, [])
  return null
}
